



























































import {
  defineComponent, ref, PropType, watch,
} from '@vue/composition-api';
import FCImage from '~/components/FCImage.vue';
import { IProduct } from '~/types/fightcamp';

export default defineComponent({
  name: 'ProductsChooseBonusItem',
  components: {
    FCImage,
  },
  props: {
    bonusOptions: {
      type: Array as PropType<IProduct[]>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const selectedGift = ref(props.bonusOptions[0].id);
    watch(selectedGift, (newVal) => {
      emit('bonusSelected', newVal);
    });
    function checkBoxClass(id: string) {
      const classes = [];
      if (selectedGift.value === id) {
        classes.push('checked');
      }
      return classes;
    }
    function image(item: IProduct) {
      return {
        url: item?.marketplace_img_url,
        alt: item?.title,
      };
    }
    return {
      selectedGift,
      toggleSelected: (id: string) => { selectedGift.value = id; },
      image,
      checkBoxClass,
    };
  },
});
